<template>
  <el-form ref="dataForm" :model="dataForm" label-width="0px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
    <!-- 公司名称 | 基金管理公司名称 -->
    <div class="pb50 messageWrap" v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED'">
      <p class="messageTitle">
        <span v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED'">{{ $t("enroll.questionnaire.proposedCompanyName") }}</span>
        <span v-else-if="businessType == 'FUND_ADMIN_CUSTOMIZED'">{{ $t("enroll.questionnaire.fundManagersName") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.proposedCompanyName"
          ref="questionnaire.proposedCompanyName"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.enter'),
              trigger: 'submit',
            },
          ]"
        >
          <el-input v-model="dataForm.questionnaire.proposedCompanyName" :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
        </el-form-item>
      </div>
    </div>

    <!-- 基金信息 - 基金托管服务 -->
    <div class="pb50 messageWrap" v-if="businessType == 'FUND_ADMIN_CUSTOMIZED'">
      <p class="messageTitle">
        {{ $t("enroll.questionnaire.fundInformation") }}
      </p>
      <div class="pt20">
        <el-form-item
          prop="fundInfoList"
          ref="fundInfoList"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.replenish'),
              trigger: 'submit',
            },
          ]"
        >
          <fund-information v-model="dataForm.fundInfoList" @fund-change="onFundInfoChange" :isReadonly="isReadonly" />
        </el-form-item>
      </div>
    </div>

    <!-- 你在新加坡设立公司准备从事什么业务? -->
    <div class="messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.workTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.workFundTitle") }}</span>
      </p>
      <div class="pt30">
        <el-form-item
          prop="questionnaire.businessPlan"
          ref="questionnaire.businessPlan"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.enter'),
              trigger: 'submit',
            },
          ]"
        >
          <el-input type="textarea" v-model="dataForm.questionnaire.businessPlan" :rows="4" :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
        </el-form-item>
      </div>
    </div>

    <!-- 公司在新加坡设立的原因 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.causeTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.causeFundTitle") }}</span>
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">{{ $t("enroll.questionnaire.causeInfo") }}</p>
          </div>
          <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.establishCause"
          ref="questionnaire.establishCause"
          :rules="[{ required: true, validator: validateCheckboxGroupWithOther, trigger: 'submit' }]"
        >
          <checkbox-group-with-other v-model="dataForm.questionnaire.establishCause" :options="byCountryFormatList('establishCauseData')" />
        </el-form-item>
      </div>
    </div>

    <!-- 公司注资以及未来运营的资金来源 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.sourceTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.sourceFundTitle") }}</span>
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">{{ $t("enroll.questionnaire.causeInfo") }}</p>
          </div>
          <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item prop="questionnaire.fundsSource" ref="questionnaire.fundsSource" :rules="[{ required: true, validator: validateCheckboxGroupWithOther, trigger: 'submit' }]">
          <checkbox-group-with-other v-model="dataForm.questionnaire.fundsSource" :options="globalFormatList('moneySourceList')" />
        </el-form-item>
      </div>
    </div>

    <!-- 您的业务是否直接或间接与克里米亚、古巴、伊朗、朝鲜或叙利亚打交道？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        {{ $t("enroll.questionnaire.contactTitle") }}
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.businessDealWithDanger"
          ref="questionnaire.businessDealWithDanger"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.businessDealWithDanger">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <div v-if="businessGenre == 'COMPANY'">
      <!--  您的供货商主要在哪些国家？ -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.questionnaire.supplierTitle") }}
        </p>
        <div class="pt30">
          <el-form-item
            prop="questionnaire.supplierCountry"
            ref="questionnaire.supplierCountry"
            :rules="[
              {
                required: true,
                message: this.$t('common.placeholder.select'),
                trigger: 'submit',
              },
            ]"
          >
            <el-select v-model="dataForm.questionnaire.supplierCountry" multiple :placeholder="$t('common.placeholder.select')" class="wd500" filterable>
              <el-option v-for="item in globalFormatList('countryList')" :key="`supplierCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
              <el-option label="N/A" value="NONE"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!--  您的客户主要在哪些国家？ -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.questionnaire.clientTitle") }}
        </p>
        <div class="pt30">
          <el-form-item
            prop="questionnaire.customerCountry"
            ref="questionnaire.customerCountry"
            :rules="[
              {
                required: true,
                message: this.$t('common.placeholder.select'),
                trigger: 'submit',
              },
            ]"
          >
            <el-select v-model="dataForm.questionnaire.customerCountry" multiple :placeholder="$t('common.placeholder.select')" class="wd500" filterable>
              <el-option v-for="item in globalFormatList('countryList')" :key="`customerCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
              <el-option label="N/A" value="NONE"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>

    <div v-else-if="businessGenre == 'FUND'">
      <!--  基金投资哪些国家? -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.questionnaire.fundsInvestedCountryTitle") }}
        </p>
        <div class="pt30">
          <el-form-item
            prop="questionnaire.fundsInvestedCountry"
            ref="questionnaire.fundsInvestedCountry"
            :rules="[
              {
                required: true,
                message: this.$t('common.placeholder.select'),
                trigger: 'submit',
              },
            ]"
          >
            <el-select v-model="dataForm.questionnaire.fundsInvestedCountry" multiple :placeholder="$t('common.placeholder.select')" class="wd500" filterable>
              <el-option v-for="item in globalFormatList('countryList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!--  基金投资哪些投资类型? -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.questionnaire.fundsInvestedTypeTitle") }}
        </p>
        <div class="pt30">
          <el-form-item
            prop="questionnaire.fundsInvestedType"
            ref="questionnaire.fundsInvestedType"
            :rules="[
              {
                required: true,
                message: this.$t('common.placeholder.select'),
                trigger: 'submit',
              },
            ]"
          >
            <el-select v-model="dataForm.questionnaire.fundsInvestedType" multiple :placeholder="$t('common.placeholder.select')" class="wd500" filterable>
              <el-option v-for="item in globalFormatList('investmentTypeList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>

    <!-- 预期未来以现金(即非银行转款、非电子钱包转款)的交易比例（单选项） -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.questionnaire.financing") }}</p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.percentageOfTransactionsByCash"
          ref="questionnaire.percentageOfTransactionsByCash"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.percentageOfTransactionsByCash">
            <el-radio :label="1">{{ $t("enroll.questionnaire.financingOption01") }}</el-radio>
            <el-radio :label="0">{{ $t("enroll.questionnaire.financingOption02") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 拟设公司的申请人/董事/股东是否为政治敏感人士，即在新加坡境内、或其他国籍和地区，或任何一个国际组织目前担任敏感的政治职务？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.atDutiesTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.atDutiesFundTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.memberPoliticallySensitive"
          ref="questionnaire.memberPoliticallySensitive"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.memberPoliticallySensitive">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 拟设公司的申请人/董事/股东是否为政治敏感人士，即在新加坡境内、或其他国籍和地区，或任何一个国际组织曾经担任敏感的政治职务？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.onceDutiesTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.onceDutiesFundTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.memberPoliticallySensitivePast"
          ref="questionnaire.memberPoliticallySensitivePast"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.memberPoliticallySensitivePast">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 拟设公司的申请人/董事/股东是否为为目前或曾经担任政治敏感人士的直系亲属和密切关系人？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.relativeTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.relativeFundTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.memberPoliticallySensitiveRelative"
          ref="questionnaire.memberPoliticallySensitiveRelative"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.memberPoliticallySensitiveRelative">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- (拟设)董事/股东是否事先有涉及欺诈或不诚实的刑事定罪？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.criminalRecord") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.criminalRecordFundTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.hasMemberDishonesty"
          ref="questionnaire.hasMemberDishonesty"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.hasMemberDishonesty">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- (拟设)公司的直接股东/董事信息 -->
    <div class="pt50 messageWrap" v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED'">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.informationProposed") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.informationFundProposed") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="companyMemberList"
          ref="companyMemberList"
          class="mb20"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.replenish'),
              trigger: 'submit',
            },
          ]"
        >
          <shareholder-director-information v-model="dataForm.companyMemberList" ref="shareholderDirectorInformationRef" :isReadonly="isReadonly" />
        </el-form-item>

        <!-- 定制化服务，是否已聘用EStar提供的名义董事 -->
        <el-form-item
          prop="questionnaire.appointNomineeDirector.type"
          ref="questionnaire.appointNomineeDirector.type"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.check'),
              trigger: 'submit',
            },
          ]"
          class="appointWrap"
          v-if="businessType == 'COMPREHENSIVE_CUSTOMIZED'"
        >
          <div class="flex-row">
            <span class="mr10 lh20">{{ $t("enroll.questionnaire.appointAny") }}</span>
            <el-radio-group v-model="dataForm.questionnaire.appointNomineeDirector.type" class="flex-row" @change="clearAgreementValidate('agreement')">
              <el-radio :label="1" class="flex-row">
                <div class="flex-row">
                  {{ $t("enroll.questionnaire.appointAnyYes") }}
                  <el-form-item
                    prop="questionnaire.appointNomineeDirector.name"
                    ref="questionnaire.appointNomineeDirector.name"
                    :rules="[
                      {
                        required: true,
                        message: this.$t('common.placeholder.enter'),
                        trigger: 'submit',
                      },
                    ]"
                    class="ml6"
                    v-if="dataForm.questionnaire.appointNomineeDirector.type == 1"
                  >
                    <el-input v-model="dataForm.questionnaire.appointNomineeDirector.name" :placeholder="$t('common.placeholder.enter')" class="wd150"></el-input>
                  </el-form-item>
                </div>
              </el-radio>
              <el-radio :label="0" class="flex-row">{{ $t("enroll.questionnaire.appointAnyNo") }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <!-- 我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。 -->
        <el-form-item
          prop="hasNomineeDirector"
          ref="hasNomineeDirector"
          class="agreementWrap"
          :rules="[
            {
              required:
                (businessType == 'SERVICE_TRANSFER' && applymentHasNomineeDirector) ||
                (businessType == 'COMPREHENSIVE_CUSTOMIZED' && dataForm.questionnaire.appointNomineeDirector.type)
                  ? true
                  : false,
              validator: validateMustCheckbox,
              trigger: 'submit',
            },
          ]"
          v-if="(businessType == 'SERVICE_TRANSFER' && applymentHasNomineeDirector) || businessType == 'COMPREHENSIVE_CUSTOMIZED'"
        >
          <el-checkbox v-model="dataForm.hasNomineeDirector" :true-label="1" :false-label="0">{{ $t("enroll.intitle.check") }}</el-checkbox>
        </el-form-item>
      </div>
    </div>

    <!-- 最终受益人信息 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.finalBeneficiary") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.finalFundBeneficiary") }}</span>
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">
              {{ $t("enroll.questionnaire.tipeBeneficiary") }}
            </p>
            <p class="pt2">
              <span class="fs12">{{ $t("common.reference") }}</span>
              <a href="https://www.acra.gov.sg/how-to-guides/setting-up-and-maintaining-register-of-registrable-controllers-(rorc)" target="_blank" class="lh14">
                https://www.acra.gov.sg/how-to-guides/setting-up-and-maintaining-register-of-registrable-controllers-(rorc)
              </a>
            </p>
          </div>
          <span slot="reference" class="fs16 lucency ml14 otn el-icon-question"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.ultimateBeneficiaryInfo"
          ref="questionnaire.ultimateBeneficiaryInfo"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.replenish'),
              trigger: 'submit',
            },
          ]"
        >
          <final-beneficiary-information
            v-model="dataForm.questionnaire.ultimateBeneficiaryInfo"
            :shareholderDataList="combinedShareholderList"
            ref="beneficiary"
            :isReadonly="isReadonly"
          />
        </el-form-item>
      </div>
    </div>

    <div v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED'">
      <!-- (拟设)公司设立日期 -->
      <div class="pt50 messageWrap">
        <p class="messageSubTitle">
          <span>{{ $t("enroll.questionnaire.proposedCompanyIncorporationDate") }}</span>
        </p>
        <div class="pt20">
          <el-form-item prop="questionnaire.proposedCompanyIncorporationDate" ref="questionnaire.proposedCompanyIncorporationDate">
            <el-date-picker
              v-model="dataForm.questionnaire.proposedCompanyIncorporationDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :placeholder="$t('common.placeholder.select')"
              class="wd500"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>

      <!-- (拟设)公司财年结束日 -->
      <div class="pt50 messageWrap">
        <p class="messageSubTitle">
          <span>{{ $t("enroll.questionnaire.proposedCompanyFinancialYearEnd") }}</span>
        </p>
        <div class="pt20">
          <el-form-item prop="questionnaire.proposedCompanyFinancialYearEnd" ref="questionnaire.proposedCompanyFinancialYearEnd">
            <el-date-picker
              v-model="dataForm.questionnaire.proposedCompanyFinancialYearEnd"
              type="date"
              format="MM-dd"
              value-format="MM-dd"
              :placeholder="$t('common.placeholder.select')"
              class="wd500"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>

      <!-- (拟设)公司第一个财年结束日 -->
      <div class="pt50 messageWrap">
        <p class="messageSubTitle">
          <span>{{ $t("enroll.questionnaire.proposedCompanyFirstFinancialYearEnd") }}</span>
        </p>
        <div class="pt20">
          <el-form-item prop="questionnaire.proposedCompanyFirstFinancialYearEnd" ref="questionnaire.proposedCompanyFirstFinancialYearEnd">
            <el-date-picker
              v-model="dataForm.questionnaire.proposedCompanyFirstFinancialYearEnd"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :placeholder="$t('common.placeholder.select')"
              class="wd500"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
    </div>

    <!-- (拟设)基金的直接股东/董事信息 -->
    <div class="pt50 messageWrap" v-if="businessType == 'FUND_ADMIN_CUSTOMIZED'">
      <p class="messageTitle">
        {{ $t("enroll.questionnaire.informationFundTitle") }}
      </p>
      <div class="pt20">
        <el-form-item
          prop="companyFundMemberList"
          ref="companyFundMemberList"
          class="mb20"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.replenish'),
              trigger: 'submit',
            },
          ]"
        >
          <fund-shareholder-director-information v-model="dataForm.companyFundMemberList" :fundInfoList="dataForm.fundInfoList" ref="fundDirector" :isReadonly="isReadonly" />
        </el-form-item>
      </div>
    </div>

    <!-- 公司注册地址 -->
    <div class="pt50 pb22 messageWrap" v-if="businessType == 'SERVICE_TRANSFER'">
      <p class="messageTitle">
        {{ $t("enroll.establish.registeredTitle") }}
      </p>
      <div class="pt30">
        <el-form-item
          prop="registeredOfficeType"
          ref="registeredOfficeType"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
          class="mb0"
        >
          <el-radio-group v-model="dataForm.registeredOfficeType">
            <div v-if="applymentHasRegisteredAddress">
              <el-radio :label="1">
                <span class="fs14">{{ $t("enroll.establish.regOptionMain") }}</span>
              </el-radio>
            </div>
            <div class="pt12">
              <el-radio :label="2">
                <span class="fs14">{{ $t("enroll.establish.otherMain") }}</span>
                <div class="hg6"></div>
                <span class="fs12 black88 pl20 lh20">{{ $t("enroll.establish.otherTransferMinor") }}</span>
              </el-radio>
            </div>
          </el-radio-group>
          <!-- 采用其他注册地址 -->
          <div class="fs12 pl20 pt14 otherWrap" v-if="dataForm.registeredOfficeType == 2">
            <div class="clearfix errorTipOffset">
              <el-form-item
                prop="registeredOfficeAddress"
                ref="registeredOfficeAddress"
                :rules="[
                  {
                    required: true,
                    message: this.$t('common.placeholder.enter'),
                    trigger: 'submit',
                  },
                ]"
                class="mb20 mr20 fl"
              >
                <span class="fs12 mr4">{{ $t("enroll.establish.address") }}</span>
                <el-input v-model="dataForm.registeredOfficeAddress" :placeholder="$t('common.placeholder.enter')" class="wd300 fs12"></el-input>
              </el-form-item>
              <el-form-item
                prop="registeredOfficeCity"
                ref="registeredOfficeCity"
                :rules="[
                  {
                    required: true,
                    message: this.$t('common.placeholder.enter'),
                    trigger: 'submit',
                  },
                ]"
                class="mb20 mr20 fl"
              >
                <span class="fs12 mr4">{{ $t("enroll.establish.city") }}</span>
                <el-input v-model="dataForm.registeredOfficeCity" :placeholder="$t('common.placeholder.enter')" class="wd300 fs12"></el-input>
              </el-form-item>
              <el-form-item
                prop="registeredOfficeCountry"
                ref="registeredOfficeCountry"
                :rules="[
                  {
                    required: true,
                    message: this.$t('common.placeholder.select'),
                    trigger: 'submit',
                  },
                ]"
                class="mb20 mr20 fl"
              >
                <span class="fs12 mr4">{{ $t("enroll.establish.country") }}</span>
                <el-select v-model="dataForm.registeredOfficeCountry" :placeholder="$t('common.placeholder.select')" filterable class="wd300">
                  <el-option v-for="item in globalFormatList('countryList')" :key="`registered-${item.value}`" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="registeredOfficePostalCode"
                ref="registeredOfficePostalCode"
                :rules="[
                  {
                    required: true,
                    message: this.$t('common.placeholder.enter'),
                    trigger: 'submit',
                  },
                ]"
                class="mb20 mr20 fl"
              >
                <span class="fs12 mr4">{{ $t("enroll.establish.code") }}</span>
                <el-input v-model="dataForm.registeredOfficePostalCode" :placeholder="$t('common.placeholder.enter')" class="wd150 fs12"></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </div>
    </div>

    <!-- 你是如何知道我们提供的公司服务(多选项，至少选一项) -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span v-if="businessGenre == 'COMPANY'">{{ $t("enroll.questionnaire.wayToGetThisTitle") }}</span>
        <span v-else-if="businessGenre == 'FUND'">{{ $t("enroll.questionnaire.wayToGetThisFundTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.wayToGetThis"
          ref="questionnaire.wayToGetThis"
          :rules="[{ required: true, validator: validateCheckboxGroupWithOther, trigger: 'submit' }]"
        >
          <checkbox-group-with-other v-model="dataForm.questionnaire.wayToGetThis" :options="globalFormatList('understandWayList')" />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import ShareholderDirectorInformation from "../../components/ShareholderDirectorInformation";
import FinalBeneficiaryInformation from "../../components/FinalBeneficiaryInformation";
import FundInformation from "./components/FundInformation";
import FundShareholderDirectorInformation from "./components/FundShareholderDirectorInformation";
import { validateLocation, strToNum } from "@/utils/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EnrollQuestionnaireSingapore",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShareholderDirectorInformation,
    FundInformation,
    FinalBeneficiaryInformation,
    FundShareholderDirectorInformation,
  },
  mixins: [validatorMixin],
  data() {
    return {
      dataForm: {
        questionnaire: {
          businessPlan: null,
          establishCause: [],
          fundsSource: [],
          businessDealWithDanger: null,
          supplierCountry: [],
          customerCountry: [],
          percentageOfTransactionsByCash: null,
          memberPoliticallySensitive: null,
          memberPoliticallySensitivePast: null,
          memberPoliticallySensitiveRelative: null,
          hasMemberDishonesty: null,
          ultimateBeneficiaryInfo: [],
          wayToGetThis: [],
          proposedCompanyName: null,
          appointNomineeDirector: {
            type: null,
            name: null,
          },
          fundsInvestedCountry: [],
          fundsInvestedType: [],
          proposedCompanyIncorporationDate: null,
          proposedCompanyFinancialYearEnd: null,
          proposedCompanyFirstFinancialYearEnd: null,
        },
        registeredOfficeType: null,
        registeredOfficeAddress: null,
        registeredOfficeCity: null,
        registeredOfficeCountry: null,
        registeredOfficePostalCode: null,
        fundInfoList: [],
        companyMemberList: [],
        companyFundMemberList: [],
        hasNomineeDirector: null,
      },
      businessGenre: null,
      businessType: null,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasRegisteredAddress", "applymentHasNomineeDirector"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    ...mapGetters("language", ["getLanguage"]),
    /** 合并公司+基金的股东/董事列表（供最终受益人拷贝功能使用） */
    combinedShareholderList() {
      return [...(this.dataForm.companyMemberList || []), ...(this.dataForm.companyFundMemberList || [])];
    },
  },
  methods: {
    /**
     * 基金信息变更处理（子组件 FundInformation 触发）
     * 当基金信息被删除或修改时，需要同步更新基金的直接股东/董事信息中的关联数据
     */
    onFundInfoChange(payload) {
      if (!payload) return;
      const { action, deletedFundName, newList, addedObj, oldFundName, updatedObj } = payload;
      let companyFundMemberListCopy = JSON.parse(JSON.stringify(this.dataForm.companyFundMemberList));

      if (action === "delete") {
        // 删除基金时，清理关联的股东/董事中的该基金引用
        companyFundMemberListCopy.forEach(item => {
          if (!item.fundsInfo || !Array.isArray(item.fundsInfo)) return;
          // 将可能的字符串JSON转为对象
          const normalizedFunds = item.fundsInfo.map(f => (typeof f === "string" ? JSON.parse(f) : f));
          item.fundsInfo = normalizedFunds.filter(child => child.fundName !== deletedFundName);
          item.sharesInfo.forEach(ele => {
            if (ele.fundsName === deletedFundName) ele.fundsName = null;
          });
        });
      } else if (action === "edit") {
        // 修改基金时，同步更新股东/董事中关联的基金信息
        companyFundMemberListCopy.forEach(item => {
          if (!item.fundsInfo || !Array.isArray(item.fundsInfo)) return;
          const normalizedFunds = item.fundsInfo.map(f => (typeof f === "string" ? JSON.parse(f) : f));
          normalizedFunds.forEach(child => {
            if (child.fundName === oldFundName) {
              child.fundName = updatedObj.fundName;
              child.fundType = updatedObj.fundType;
              child.fundRegistrationCountry = updatedObj.fundRegistrationCountry;
              child.fundRegistration = updatedObj.fundRegistration;
            }
          });
          item.sharesInfo.forEach(ele => {
            if (ele.fundsName === oldFundName) {
              ele.fundsName = updatedObj.fundName;
            }
          });
        });
      }

      this.$set(this.dataForm, "companyFundMemberList", companyFundMemberListCopy);
    },
    // 移除[我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。]校验结果
    clearAgreementValidate(props) {
      this.$refs["dataForm"].clearValidate(props);
    },
    // 数据初始化处理
    dataInit() {
      const applymentDetailCopy = JSON.parse(JSON.stringify(this.applymentDetail));
      // 主体类型
      this.businessGenre = applymentDetailCopy.businessGenre;
      // 业务类型
      this.businessType = applymentDetailCopy.businessType;

      const questionnaireCopy = applymentDetailCopy.questionnaire || {};
      this.dataForm = {
        questionnaire: {
          businessPlan: questionnaireCopy.businessPlan || null,
          establishCause: questionnaireCopy.establishCause || [],
          fundsSource: questionnaireCopy.fundsSource || [],
          supplierCountry: questionnaireCopy.supplierCountry || [],
          customerCountry: questionnaireCopy.customerCountry || [],
          ultimateBeneficiaryInfo: questionnaireCopy.ultimateBeneficiaryInfo || [],
          wayToGetThis: questionnaireCopy.wayToGetThis || [],
          proposedCompanyName: questionnaireCopy.proposedCompanyName || null,
          fundsInvestedCountry: questionnaireCopy.fundsInvestedCountry || [],
          fundsInvestedType: questionnaireCopy.fundsInvestedType || [],
          proposedCompanyIncorporationDate: questionnaireCopy.proposedCompanyIncorporationDate || null,
          proposedCompanyFinancialYearEnd: questionnaireCopy.proposedCompanyFinancialYearEnd || null,
          proposedCompanyFirstFinancialYearEnd: questionnaireCopy.proposedCompanyFirstFinancialYearEnd || null,
          businessDealWithDanger: strToNum(questionnaireCopy.businessDealWithDanger),
          percentageOfTransactionsByCash: strToNum(questionnaireCopy.percentageOfTransactionsByCash),
          memberPoliticallySensitive: strToNum(questionnaireCopy.memberPoliticallySensitive),
          memberPoliticallySensitivePast: strToNum(questionnaireCopy.memberPoliticallySensitivePast),
          memberPoliticallySensitiveRelative: strToNum(questionnaireCopy.memberPoliticallySensitiveRelative),
          hasMemberDishonesty: strToNum(questionnaireCopy.hasMemberDishonesty),
          appointNomineeDirector: questionnaireCopy.appointNomineeDirector || { type: null, name: null },
        },
        registeredOfficeType: strToNum(applymentDetailCopy.registeredOfficeType),
        registeredOfficeAddress: applymentDetailCopy.registeredOfficeAddress || null,
        registeredOfficeCity: applymentDetailCopy.registeredOfficeCity || null,
        registeredOfficeCountry: applymentDetailCopy.registeredOfficeCountry || null,
        registeredOfficePostalCode: applymentDetailCopy.registeredOfficePostalCode || null,
        fundInfoList: applymentDetailCopy.fundInfoList || [],
        companyMemberList: applymentDetailCopy.companyMemberList || [],
        companyFundMemberList: applymentDetailCopy.companyFundMemberList || [],
        hasNomineeDirector: strToNum(applymentDetailCopy.hasNomineeDirector),
      };
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return {
        ...this.dataForm,
      };
    },
    // 触发必填校验(由父级触发) - 仅下一步时调用
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            if (this.businessType == "SERVICE_TRANSFER" || this.businessType == "COMPREHENSIVE_CUSTOMIZED" || this.businessType == "FUND_ADMIN_CUSTOMIZED") {
              // 校验公司的直接股东/董事信息
              if (this.$refs.shareholderDirectorInformationRef && !this.$refs.shareholderDirectorInformationRef.validate()) {
                reject("custom prompt: Shareholder/Director validation failed");
                return;
              }
            }
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>

<style lang="scss" scoped>
.messageTitle,
.messageSubTitle {
  border-radius: 2px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
}

.messageTitle:before {
  content: "*";
  margin-right: 4px;
  color: #f56c6c;
}

.dataForm ::v-deep input::-webkit-outer-spin-button,
.dataForm ::v-deep input::-webkit-inner-spin-button {
  appearance: none !important;
}

.dataForm ::v-deep input[type="number"] {
  appearance: textfield !important;
}

.dataForm ::v-deep {
  .el-checkbox {
    width: 470px;
    margin-right: 0px;
    padding-right: 30px;
    box-sizing: border-box;
  }

  .el-radio {
    margin-right: 18px;

    &:last-child {
      margin-right: 0;
    }
  }

  .el-radio__label {
    padding-left: 5px;
  }
}

.agreementWrap ::v-deep {
  .el-checkbox {
    width: 100% !important;
  }

  .el-checkbox__label {
    width: 98%;
    white-space: initial;
    font-size: 14px;
    vertical-align: top;
    margin-top: 8px;
  }
}

.appointWrap ::v-deep {
  .el-radio__inner {
    margin-top: 3px;
  }
}
</style>
